<footer class="text-center p-5">
  <div class="container">
    <div class="mt-4">
      <div class="row align-items-stretch">
        <div class="col-sm-12 col-lg-5">
          <div class="d-flex flex-wrap">
            <div class="col-sm-12 col-lg-6 text-start">
              <img
                src="assets/images/logos/logo-white-no-text.png"
                class="logo-footer w-100" />
            </div>
            <div class="col-sm-12 col-lg-6 text-start">
              <h3>About TSOLife</h3>
              <p>
                TSOLife's resident insight and experience platform is designed
                to empower senior living operators with actionable insights that
                facilitate real-time data-driven decisions.
              </p>
            </div>
          </div>
        </div>

        <div class="custom-col mx-2 d-lg-flex justify-content-center d-sm-none">
          <hr class="bg-white footer-hr" />
        </div>

        <div class="col-sm-12 col-lg-5">
          <div class="d-flex text-start text-light">
            <div class="me-5">
              <ul class="list-unstyled">
                <li class="mb-4">
                  <a routerLink="resident-insights">Resident insights</a>
                </li>
                <li class="mb-4">
                  <a routerLink="resident-experiences">Resident Experiences</a>
                </li>
                <li class="mb-4">
                  <a routerLink="quality-of-life">Quality of Life</a>
                </li>
                <li class="mb-4">
                  <a routerLink="sales-support-tool">Sales Support Tool</a>
                </li>
                <li class="mb-4">
                  <a routerLink="survey-feedback-platform"
                    >Survey and Feedback</a
                  >
                </li>
              </ul>
            </div>
            <div class="ms-5">
              <ul class="list-unstyled">
                <li class="mb-4">
                  <a
                    href="https://calendly.com/tsolife-david-sawyer/60min"
                    target="_blank"
                    >Schedule a Demo</a
                  >
                </li>
                <li class="mb-4"><a routerLink="legal/msla">MSLA</a></li>
                <li class="mb-4">
                  <a routerLink="privacy">Privacy Policy</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-5">
          <p class="mt-5">© 2022 TSOLife. All Rights Reserved.</p>
        </div>

        <div class="custom-col mx-2 d-flex justify-content-center">
          <hr class="bg-white footer-hr" />
        </div>

        <div class="col-5">
          <div class="row justify-content-start media-logos">
            <div class="col-auto">
              <div class="row mt-5">
                <div class="col">
                  <a
                    href="https://www.linkedin.com/company/tsolife-llc"
                    target="_blank">
                    <img src="assets/images/logos/linkedin-white.png" />
                  </a>
                </div>
                <div class="col">
                  <a href="https://www.facebook.com/TSOLife1" target="_blank"
                    ><img src="assets/images/logos/facebook-white.png"
                  /></a>
                </div>
                <div class="col">
                  <a href="https://www.instagram.com/tsolife/" target="_blank">
                    <img
                      src="assets/images/logos/instagram-white.png"
                      target="_blank" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
